import { Box, Button, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { z } from 'zod';
import { IRAN_MOBILE_REGEX } from '../../../constants/regex';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import axios from 'axios';
import IResponse from '../../../interfaces/response';
import { useContext } from 'react';
import { UserContext } from '../../../contexts/UserContext';

const recoverPasswordSchema = z.object({
	emailOrPhone: z.string().refine(value => z.string().email().safeParse(value).success || IRAN_MOBILE_REGEX.test(value), { message: 'invalid_email_or_phone_message' }),
});

const RecoverPassword = () => {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<z.infer<typeof recoverPasswordSchema>>({
		resolver: zodResolver(recoverPasswordSchema),
	});

	const { t } = useTranslation();
	const navigate = useNavigate();

	const { setRecoverEmailOrPhone } = useContext(UserContext);

	const handleRecoverPassword = (data: z.infer<typeof recoverPasswordSchema>) => {
		axios<IResponse<string>>({
			url: '/users/forgot-pass/check-username',
			method: 'POST',
			data: {
				login: data?.emailOrPhone,
			},
		}).then(res => {
			if (res.data.success) {
				setRecoverEmailOrPhone(data?.emailOrPhone);
				navigate('/auth/confirm-code');
			}
		});
	};

	return (
		<Box>
			<form className="flex w-full flex-col gap-y-6" onSubmit={handleSubmit(handleRecoverPassword)}>
				<TextField className="w-full" id="outlined-required" label={t('email-input-placeholder')} {...register('emailOrPhone')} error={!!errors.emailOrPhone} helperText={t(errors.emailOrPhone?.message!)} />
				<Button type="submit" size="large" variant="contained" className="text-base font-normal">
					{t('recover-password')}
				</Button>
			</form>
		</Box>
	);
};

export default RecoverPassword;
